import generateThumbnailFromPreview from 'utils/generateThumbnailFromPreview'
import { uploadScreenshot } from 'services/screenshot'

import Renderer from 'Renderer'

const dataUrlToFile = async (dataUrl, fileName, mimeType) => {
    const response = await fetch(dataUrl)
    const blob = await response.blob()
    return new File([blob], fileName, { type: mimeType })
}

const uploadPreviewScreenshot = async (fileName, renderSessionId, metadata = {}) => {
    // Avoid taking a screenshot when the renderer is still not fully initialized
    // This can (rarely) happen when the furnitureItems are loaded faster than the scene's metadata
    const renderer = Renderer.getInstance()
    if (!renderer || !renderer.ThreeWGLrenderer || !renderer.canvas.width || !renderer.canvas.height) {
        return Promise.reject()
    }

    // Since a high quality screenshot is not needed in this context; the thumbnail
    // is generated directly instead of using the renderer's roomScreenshot API
    const scale = 0.5
    const jpegQuality = 0.65
    const { thumbDataUrl: imageData, imageIsBlack } = await generateThumbnailFromPreview(scale, jpegQuality)
    const mimeType = 'image/jpeg'
    const file = await dataUrlToFile(imageData, fileName, mimeType)
    const uuid = await uploadScreenshot(file, renderSessionId, metadata)
    return {
        uuid,
        imageIsBlack,
    }
}

export default uploadPreviewScreenshot
